import { useTranslation } from 'react-i18next'
import { VaBalanceLog } from '../../services/users.service'
import { formatCurrency, formatDateTime } from '../../utils/formatters'

/** Audit list for one member's VA Balance changes (who, when, old → new). */
export default function VaBalanceHistory({ logs }: { logs: VaBalanceLog[] }) {
  const { t } = useTranslation()

  return (
    <div>
      <p className="text-xs font-medium text-gray-500 uppercase tracking-wide mb-3">
        {t('finance.history', 'VA Balance History')}
      </p>
      {logs.length === 0 ? (
        <p className="text-sm text-gray-500 italic">
          {t('finance.noChanges', 'No changes recorded yet')}
        </p>
      ) : (
        <ul className="divide-y divide-gray-100">
          {logs.map((log) => (
            <li key={log.id} className="py-3">
              <div className="flex items-start justify-between gap-4">
                <div>
                  <p className="text-sm text-gray-900">
                    {log.changedBy
                      ? `${log.changedBy.firstName} ${log.changedBy.lastName}`.trim()
                      : '—'}
                    {log.changedBy?.memberId && (
                      <span className="ml-2 font-mono text-xs text-gray-400">
                        {log.changedBy.memberId}
                      </span>
                    )}
                  </p>
                  <p className="text-xs text-gray-500">{formatDateTime(log.createdAt)}</p>
                </div>
                <p className="text-sm font-medium text-gray-900 whitespace-nowrap">
                  {formatCurrency(log.previousBalance ?? 0)}
                  <span className="mx-1 text-gray-400">→</span>
                  {formatCurrency(log.newBalance)}
                </p>
              </div>
              {log.note && <p className="mt-1 text-xs text-gray-500">{log.note}</p>}
            </li>
          ))}
        </ul>
      )}
    </div>
  )
}
